module.exports = __webpack_public_path__ + "static/media/203_SHOT_087.02acde09.webp";